export default {
  "alignLeft": "RjvN5",
  "textWrapNowrap": "f6Dgm",
  "alignRight": "_4e696",
  "alignCenter": "xfPnQ",
  "sizeFullWidth": "GXEs5",
  "renderedInTable": "N6lsh",
  "sizeOriginal": "WCuSu",
  "sizeContent": "Le05-",
  "sizeSmall": "vn-02",
  "sizeSmallCenter": "zruZZ",
  "flex": "vJc2R",
  "LEFT": "qvGEn",
  "CENTER": "_5Ugti",
  "RIGHT": "knYaR",
  "AUTO": "hRuKg",
  "JUSTIFY": "xO7IS"
};